import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// routes
import {
  IS_LOGGED_IN,
  EMAIL_VERIFY,
  RESEND_EXCO_USER_EMAIL,
  LOGIN_ACCOUNT_CHR,
  VERIFY_TOKEN,
  LOGOUT_ACCOUNT_CHR,
  GET_ALL_ROLES,
  CREATE_ACCOUNT_CHR,
  UPDATE_ACCOUNT_CHR,
  CHANGE_PRIMARY_ROLE,
  DELETE_ACCOUNT_CHR,
  GET_ACCOUNTS_CHR,
  GET_ALL_EXEC,
  GET_ALL_AM,
  ACTIVATE_ACCOUNT_CHR,
  GET_CURRENT_USER,
  GET_CURRENT_USER_BY_ROLE,
  GET_CURRENT_ROLES,
  UPLOAD_PROFILE_PIC,
  ACTIVATE_ACCOUNT_CHR_MAIL_SEND,
  RESEND_ACTIVATION_MAIL,
  RESEND_ACTIVATION_MAIL_CHR,
  CREATE_ACCOUNT_MAPPING_CHR,
  GET_ACCOUNTS_MAPPING_CHR,
  DELETE_ACCOUNT_MAPPING_CHR,
} from "../../utils/routes";

// ---------------------------------------------------------------------------------

export const verifyLogin = createAsyncThunk(
  "auth/verifyLogin",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(IS_LOGGED_IN, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const verifyEmail = createAsyncThunk(
  "auth/verifyEmail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(EMAIL_VERIFY, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const resendEmail = createAsyncThunk(
  "auth/resendEmail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(RESEND_EXCO_USER_EMAIL, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const login = createAsyncThunk(
  "auth/login",
  async (data, { rejectWithValue }) => {
    let authRQ = data.token;
    delete data.token;
    try {
      const response = await axios.post(LOGIN_ACCOUNT_CHR, data, {
        headers: {
          Authorization: `Bearer ${authRQ}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const verifyToken = createAsyncThunk(
  "auth/verifyToken",
  async (data, { rejectWithValue }) => {
    let authRQ = data.passToken;
    delete data.passToken;
    try {
      const response = await axios.post(VERIFY_TOKEN, data, {
        headers: {
          Authorization: `Bearer ${authRQ}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const logout = createAsyncThunk(
  "auth/logout",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(LOGOUT_ACCOUNT_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getAllRoles = createAsyncThunk(
  "auth/getAllRoles",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(GET_ALL_ROLES, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const createAccountChr = createAsyncThunk(
  "auth/createAccountChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CREATE_ACCOUNT_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const createAccountMappingChr = createAsyncThunk(
  "auth/createAccountMappingChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CREATE_ACCOUNT_MAPPING_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateAccountChr = createAsyncThunk(
  "auth/updateAccountChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(UPDATE_ACCOUNT_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const changePrimaryRole = createAsyncThunk(
  "auth/changePrimaryRole",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CHANGE_PRIMARY_ROLE, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteAccountChr = createAsyncThunk(
  "auth/deleteAccountChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(DELETE_ACCOUNT_CHR, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteAccountMappingChr = createAsyncThunk(
  "auth/deleteAccountMappingChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(DELETE_ACCOUNT_MAPPING_CHR, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getAccountChr = createAsyncThunk(
  "auth/getAccountChr",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(GET_ACCOUNTS_CHR, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getAccountMappingChr = createAsyncThunk(
  "auth/getAccountMappingChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${GET_ACCOUNTS_MAPPING_CHR}?id=${data}`,
        { withCredentials: true }
      );
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getCurrentUser = createAsyncThunk(
  "auth/getCurrentUser",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(GET_CURRENT_USER, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getCurrentUserByRole = createAsyncThunk(
  "auth/getCurrentUserByRole",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${GET_CURRENT_USER_BY_ROLE}/${data}`, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getCurrentRoles = createAsyncThunk(
  "auth/getCurrentRoles",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(GET_CURRENT_ROLES, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getAllExec = createAsyncThunk(
  "auth/getAllExec",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(GET_ALL_EXEC, { withCredentials: true });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getAllAM = createAsyncThunk(
  "auth/getAllAM",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(GET_ALL_AM, { withCredentials: true });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const activateAccountChr = createAsyncThunk(
  "auth/activateAccountChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(ACTIVATE_ACCOUNT_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const activateAccountChrMailSend = createAsyncThunk(
  "auth/activateAccountChrMailSend",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(ACTIVATE_ACCOUNT_CHR_MAIL_SEND, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const resendActivationMail = createAsyncThunk(
  "auth/resendActivationMail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(RESEND_ACTIVATION_MAIL_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const uploadProfilePic = createAsyncThunk(
  "auth/uploadProfilePic",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(UPLOAD_PROFILE_PIC, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

// ---------------------------------------------------------------------------------

const authSlice = createSlice({
  name: "auth",
  initialState: {
    loading: false,
    isLoggedIn: "",
    loginToken: "",
    passwordToken: "",
    baseString: "",
    rq: "",
    loginData: {},
    accountData: [],
    accountMappingdata: [],
    execData: [],
    amData: [],
    rolesData: [],
    userRolesData: [],
    selectedData: {},
    selectedAccountData: {},
    message: "",
    errMessage: "",
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    selectRow: (state, action) => {
      state.selectedData = action?.payload.length > 0 && action?.payload[0];
    },
    rowSelect: (state, action) => {
      state.selectedAccountData = action?.payload;
    },
    resetBaseString: (state, action) => {
      state.baseString = "";
    },
  },
  extraReducers: {
    [verifyLogin.pending]: (state, action) => {
      state.loading = true;
    },
    [verifyLogin.fulfilled]: (state, action) => {
      state.loading = false;
      state.isLoggedIn = action?.payload?.data;
    },
    [verifyLogin.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getAllRoles.pending]: (state, action) => {
      state.loading = true;
    },
    [getAllRoles.fulfilled]: (state, action) => {
      state.loading = false;
      state.rolesData = action?.payload?.data;
    },
    [getAllRoles.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [createAccountChr.pending]: (state, action) => {
      state.loading = true;
    },
    [createAccountChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createAccountChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [createAccountMappingChr.pending]: (state, action) => {
      state.loading = true;
    },
    [createAccountMappingChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createAccountMappingChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [uploadProfilePic.pending]: (state, action) => {
      state.loading = true;
    },
    [uploadProfilePic.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [uploadProfilePic.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [updateAccountChr.pending]: (state, action) => {
      state.loading = true;
    },
    [updateAccountChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateAccountChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [changePrimaryRole.pending]: (state, action) => {
      state.loading = true;
    },
    [changePrimaryRole.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [changePrimaryRole.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteAccountChr.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteAccountChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteAccountChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [deleteAccountMappingChr.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteAccountMappingChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteAccountMappingChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [getAccountChr.pending]: (state, action) => {
      state.loading = true;
    },
    [getAccountChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.accountData = action?.payload?.data;
    },
    [getAccountChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [getAccountMappingChr.pending]: (state, action) => {
      state.loading = true;
    },
    [getAccountMappingChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.accountMappingdata = action?.payload?.data;
    },
    [getAccountMappingChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },

    [getCurrentUser.pending]: (state, action) => {
      state.loading = true;
    },
    [getCurrentUser.fulfilled]: (state, action) => {
      state.loading = false;
      state.loginData = action?.payload?.data;
    },
    [getCurrentUser.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getCurrentUserByRole.pending]: (state, action) => {
      state.loading = true;
    },
    [getCurrentUserByRole.fulfilled]: (state, action) => {
      state.loading = false;
      state.loginData = action?.payload?.data;
    },
    [getCurrentUserByRole.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getCurrentRoles.pending]: (state, action) => {
      state.loading = true;
    },
    [getCurrentRoles.fulfilled]: (state, action) => {
      state.loading = false;
      state.userRolesData = action?.payload?.data;
    },
    [getCurrentRoles.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [verifyEmail.pending]: (state, action) => {},
    [verifyEmail.fulfilled]: (state, action) => {
      state.loading = false;
      state.loginToken = action?.payload?.data?.data?.token;
      // state.rq = action?.payload?.data?.data?.rq;
      state.message = action?.payload?.data?.message;
    },
    [verifyEmail.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [resendEmail.pending]: (state, action) => {
      state.loading = true;
    },
    [resendEmail.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [resendEmail.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [login.pending]: (state, action) => {
      state.loading = true;
    },
    [login.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
      state.passwordToken = action?.payload?.data?.data?.token;
      state.baseString = action?.payload?.data?.data?.baseString;
    },
    [login.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [verifyToken.pending]: (state, action) => {
      state.loading = true;
    },
    [verifyToken.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
      state.loginData = action?.payload?.data;
    },
    [verifyToken.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [logout.pending]: (state, action) => {
      state.loading = true;
    },
    [logout.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [logout.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [activateAccountChr.pending]: (state, action) => {
      state.loading = true;
    },
    [activateAccountChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [activateAccountChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [activateAccountChrMailSend.pending]: (state, action) => {
      state.loading = true;
    },
    [activateAccountChrMailSend.fulfilled]: (state, action) => {
      state.loading = false;
      state.baseString = action?.payload?.data?.data?.baseString;
      state.message = action?.payload?.data?.message;
    },
    [activateAccountChrMailSend.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [resendActivationMail.pending]: (state, action) => {
      state.loading = true;
    },
    [resendActivationMail.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [resendActivationMail.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getAllExec.pending]: (state, action) => {
      state.loading = true;
    },
    [getAllExec.fulfilled]: (state, action) => {
      state.loading = false;
      state.execData = action?.payload?.data;
    },
    [getAllExec.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getAllAM.pending]: (state, action) => {
      state.loading = true;
    },
    [getAllAM.fulfilled]: (state, action) => {
      state.loading = false;
      state.amData = action?.payload?.data;
    },
    [getAllAM.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
  },
});

export const {
  resetMessage,
  rowSelect,
  resetErrMessage,
  selectRow,
  resetBaseString,
} = authSlice.actions;

export default authSlice.reducer;
